import React, {useContext} from 'react';
import {Trans, withTranslation} from "react-i18next";

function GeneralErrorComponent(props) {
  return (
    <div className="alert">
      <p>
        <Trans i18nKey="error_generic" />
      </p>
    </div>
  )
}

export default withTranslation()(GeneralErrorComponent);
